export enum Dtm {
  MeuPlano = "SA:LG:SYDLE:Checkout:{{Product}}:MeuPlano",
  MeuPacote = "SA:LG:SYDLE:Checkout:{{Product}}:MeuPacote",
  Identificacao = "SA:LG:SYDLE:Checkout:{{Product}}:Identificacao",
  Pagamento = "SA:LG:SYDLE:Checkout:{{Product}}:Pagamento",
  PagamentoCompraDeslogada = "SA:LG:SYDLE:CheckoutCompraDeslogada:{{Product}}:Pagamento",
  CadastroDeslogado = "SA:NL:SYDLE:CheckoutCompraDeslogada:{{Product}}:CadastroDeslogado",
  SucessoDeslogado = "SA:LG:SYDLE:CheckoutCompraDeslogada:{{Product}}:Sucesso",
  Sucesso = "SA:LG:SYDLE:Checkout:{{Product}}:Sucesso",
  NotFound = "SA:LG:SYDLE:Checkout:404",
  Cancelamento = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:Cancelamento",
  CancelamentoSucceso = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:CancelamentoSucesso",
  AlteracaoDePagamento = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:AlterarPagamento",
  AlteracaoDePagamentoSuccesso = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:AlterarPagamentoSucesso",
  RetencaoBoletoVencido = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:SeuBoletoVenceu",
  RetencaoBoletoVencidoSucesso = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:SeuBoletoVenceuSucesso",
  RetencaoCartaoInvalido = " SA:LG:SYDLE:AutoAtendimento:{{Product}}:RetencaoCartaoInvalido",
  RetencaoCartaoInvalidoSucesso = " SA:LG:SYDLE:AutoAtendimento:{{Product}}:RetencaoCartaoInvalidoSucesso",
  Rentencao = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:Retencao",
  RetencaoSucesso = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:RetencaoSucesso",
  AutoAtendimentoSucesso = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:Sucesso",
  RetencaoErroPagamento = "SA:LG:SYDLE:Checkout:{{Product}}:RetencaoErroPagamento",
  Processando = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:Processando",
  ProcessamentoTimeout = "SA:LG:SYDLE:Checkout:{{Product}}:ProcessamentoTimeout",
  VitrineUpgrade = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:VitrineUpgrade",
  Upgrade = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:Upgrade",
  UpgradeSucesso = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:UpgradeSucesso",
  SegundaVia = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:SegundaVia',
  SegundaViaSucesso = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:SegundaViaSucesso',
  AtivarRecarga = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:AtivarRecarga',
  AtivarRecargaSucesso = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:AtivarRecargaSucesso',
  AtivarRecargaPagamento = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:AtivarRecarga',
  AlterarRecarga = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:AlterarRecarga',
  AlterarRecargaSucesso = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:AlterarRecarga',
  DesativarRecarga = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:DesativarRecarga',
  DesativarRecargaSucesso = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:DesativarRecarga',
  AlteracaoDePagamentoRecarga = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:AlterarPagamentoRecarga',
  AlteracaoDePagamentoRecargaSucesso = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:AlterarPagamentoRecarga',
  DesistirCancelamento = 'SA:LG:SYDLE:AutoAtendimento:Assinatura:Cancelamento:DesistirCancelamento',
  DesistirCompra = 'SA:LG:SYDLE:AutoAtendimento:Assinatura:Cancelamento:DesistirCompra',
  PagamentoReconhecido = 'SA:LG:SYDLE:Checkout:{{Product}}:PagamentoReconhecido',
  PagamentoReconhecidoDeslogado =  'SA:LG:SYDLE:CheckoutCompraDeslogada:{{Product}}:PagamentoReconhecido',
  PagamentoReconhecidoUpgrade = 'SA:LG:SYDLE:Checkout:{{Product}}:Upgrade:PagamentoReconhecido',
  PagamentoReconhecidoAutoAtendimento = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:PagamentoReconhecido',
  CodigoPagamentoExpirou = 'SA:LG:SYDLE:Checkout:{{Product}}:CodigoPagamentoExpirou',
  CodigoPagamentoExpirouAutoAtendimento = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:CodigoPagamentoExpirou',
  NovoCodigoPix = 'SA:LG:SYDLE:Checkout:{{Product}}:NovoCodigoPIX',
  NovoCodigoPixAutoAtendimento = 'SA:LG:SYDLE:AutoAtendimento:{{Product}}:NovoCodigoPIX',
  ExibicaoModalSugestao = 'SA:LG:SYDLE:Checkout:{{Product}}:SuggesstionProductModal',
  CancelamentoPasso1 = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:CancelamentoPasso1",
  CancelamentoPasso2 = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:CancelamentoPasso2",
  CancelamentoPasso3 = "SA:LG:SYDLE:AutoAtendimento:{{Product}}:RetencaoDesconto",
  AntecipacaoRenovacaoClientePagamento = "SA:LG:SYDLE:Checkout:{{Product}}:AntecipacaoRenovacaoCliente:Pagamento",
  AntecipacaoRenovacaoClienteSucesso = "SA:LG:SYDLE:Checkout:{{Product}}:AntecipacaoRenovacaoCliente:Sucesso"
}

export enum Rules {
  CancelarPlano = 'CancelarPlano',
  RetencaoSucesso = 'RetencaoSucesso',
  CustomPageView = 'CustomPageView',
  PageLoad = 'CustomPageLoad',
  CancelarPlanoDesistirCancelamento = 'CancelarPlanoDesistirCancelamento',
  CancelarPlanoDesistirCompra = 'CancelarPlanoDesistirCompra'
}

export enum Mapping {
  'saude-do-seu-negocio' = 'Saúde do seu Negócio',
  'consulta-e-recuperacao-de-dividas' = 'Pacote de Credito MPME',
  'monitore-clientes' = 'Serasa Monitora',
  'lista-online' = 'Prospeccao',
  'plano-mensal' = "Assinatura",
  'plano-mensal-recarga-pontual' = "AssinaturaRecargaPontual",
  'descomplica' = "Descomplica"
}

export function getDtm(pageName, classification): string {
  let mapped = Mapping[classification];
  return pageName.replace('{{Product}}', mapped);
}

export function getNameMapping(classification): string {
  return Mapping[classification] ? Mapping[classification] : classification;
}
